import {FormApi, Unsubscribe} from "final-form";

type finalErrorType = {
    [key: string]: string | undefined;
} & {
    examScore?: {
        score?: string;
        enabled?: string;
    }[];
};

export const focusFirstFormLogic = <T extends Record<string, unknown>>(
    form: FormApi<T, Partial<T>>,
): void => {
    const {errors, submitErrors} = form.getState();

    const finalErrors = {...errors, ...submitErrors} as finalErrorType;
    //hack..we need to fix later
    let formIndex = 0;
    if (document.forms.length === 3) {
        formIndex = 2;
    }
    if (document.forms[formIndex]) {
        const nodeList: NodeListOf<HTMLInputElement | HTMLDivElement> = document.forms[
            formIndex
        ].querySelectorAll("[name]:not(disabled)");

        for (let itemCounter = 0; itemCounter < nodeList.length; itemCounter++) {
            const item = nodeList[itemCounter];
            const itemNameAttributeVal = item.getAttribute("name");
            if (finalErrors?.examScore) {
                for (let i = 0; i < finalErrors.examScore.length; i++) {
                    if (finalErrors.examScore[i]?.["score"]) {
                        finalErrors[`examScore[${i}][score]`] = finalErrors.examScore[i]["score"];
                        break;
                    }
                    if (finalErrors.examScore[i]?.["enabled"]) {
                        finalErrors[`examScore[${i}][enabled]`] =
                            finalErrors.examScore[i]["enabled"];
                        break;
                    }
                }
            }

            if (
                finalErrors &&
                itemNameAttributeVal &&
                typeof finalErrors[itemNameAttributeVal] !== "undefined"
            ) {
                item.focus();
                break;
            }
        }
    }
};

const focusOnFirstFieldDecorator = () => <T extends Record<string, unknown>>(
    form: FormApi<T>,
): Unsubscribe => {
    // Save original submit function
    const originalSubmit = form.submit;

    const afterSubmit = () => {
        focusFirstFormLogic(form);
        // const {errors} = form.getState();
        // const nodeList: NodeListOf<
        //     HTMLInputElement | HTMLDivElement
        // > = document.forms[0].querySelectorAll("[name]");

        // for (
        //     let itemCounter = 0;
        //     itemCounter < nodeList.length;
        //     itemCounter++
        // ) {
        //     const item = nodeList[itemCounter];
        //     const itemNameAttributeVal = item.getAttribute("name");
        //     if (
        //         errors &&
        //         itemNameAttributeVal &&
        //         typeof errors[itemNameAttributeVal] !== "undefined"
        //     ) {
        //         item.focus();
        //         break;
        //     }
        // }
    };

    // Rewrite submit function
    form.submit = () => {
        const result = originalSubmit.call(form);
        if (result && typeof result.then === "function") {
            // async
            void result.then(afterSubmit);
        } else {
            // sync
            afterSubmit();
        }
        return result;
    };

    return () => {
        form.submit = originalSubmit;
    };
};

export default focusOnFirstFieldDecorator;
